import { ActivatedRouteSnapshot, CanDeactivate, RouterStateSnapshot, UrlTree } from '@angular/router';
import { IChangesAssertion } from './changes-assertion.interface';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable()
export class HasUnsavedChangesGuard implements CanDeactivate<IChangesAssertion> {

  canDeactivate(component: IChangesAssertion, currentRoute: ActivatedRouteSnapshot, currentState: RouterStateSnapshot, nextState?: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return component.assertUnsavedChanges(nextState);
  }

}
